/**
 * Copyright (c) 2021 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import React from 'react';
import {
  UploadItem as ConsumerUploadItem,
  UploadItemProps as ConsumerUploadItemProps,
} from '@blend/consumer-components';
import { useConsumerTheme } from '../../../../../hooks/useConsumerTheme';

type UploadItemProps = Omit<ConsumerUploadItemProps, 'actionColor'>;

export const UploadItem: React.FC<UploadItemProps> = ({ ...props }) => {
  const {
    appConfig: { colors },
  } = useConsumerTheme();
  return <ConsumerUploadItem data-it="UploadItem" actionColor={colors.action} {...props} />;
};
